import { render, staticRenderFns } from "./FlipCardsButtons.vue?vue&type=template&id=25d9d397"
import script from "./FlipCardsButtons.vue?vue&type=script&lang=js"
export * from "./FlipCardsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports